module.exports = __webpack_public_path__ + "img/saska.5a214d39.jpg";